import { render, staticRenderFns } from "./AdminPriceSettings.vue?vue&type=template&id=1cd2dee6&lang=pug&"
import script from "./AdminPriceSettings.vue?vue&type=script&lang=js&"
export * from "./AdminPriceSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminPriceSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports